module.exports = __webpack_public_path__ + "static/media/Number2.d3b1168d.svg";